import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export type IconToggleButtonProps = Omit<TouchableProps, 'haptic'>;

const BASE =
  'p-2 rounded-full text-ink-faint active:bg-soft active:scale-95 transition-all touch-manipulation';

export const IconToggleButton: React.FC<IconToggleButtonProps> = ({ className, ...rest }) => (
  <Touchable haptic="transition" className={className ? `${BASE} ${className}` : BASE} {...rest} />
);
